import { render, staticRenderFns } from "./BrigadeGeoTrackerMarker.vue?vue&type=template&id=05890054&"
import script from "./BrigadeGeoTrackerMarker.vue?vue&type=script&lang=js&"
export * from "./BrigadeGeoTrackerMarker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QIcon,QTooltip,QItem,QItemSection,QItemLabel} from 'quasar'
component.options.components = Object.assign({QIcon,QTooltip,QItem,QItemSection,QItemLabel}, component.options.components || {})
